import {Injectable} from "@angular/core";
import {
  HTTP_INTERCEPTORS,
  HttpErrorResponse,
  HttpEvent,
  HttpHandler, HttpHeaders,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import {AuthService} from "./auth.service";
import {catchError, Observable, tap, throwError} from "rxjs";
import {ApiService} from "../../services/api.service";

@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService, private api: ApiService) {

  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    const session = this.authService.getSession()
    // console.warn('ATANAS', session)
    if (session) {
      authReq = req.clone({
        setHeaders: {
          'Authorization': `Bearer ${session.accessToken}`
        }
      })
    }
    return next.handle(authReq)
  }
}

export const authInterceptorProviders = [
  { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true }
]
